import RadioButton from '@alexis/components/RadioButton';
import { clsx } from '@alexis/helpers/clsx';
import React, { forwardRef } from 'react';

import styles from './RadioGroup.module.scss';

interface Option<TValue extends string | number> {
  value: TValue;
  label: React.ReactNode;
}

interface RadioGroupProps<TValue extends string | number> {
  className?: string;
  onChange?: (value: TValue) => void;
  value?: TValue;
  hasError?: boolean;
  options: Option<TValue>[];
}

const ForwardedRadioGroup = <TValue extends string | number>(
  { value: valueProp, onChange, hasError, options, className }: RadioGroupProps<TValue>,
  ref: any,
) => {
  return (
    <div ref={ref} className={clsx(styles.container, className)}>
      {options.map(({ value, label }) => (
        <div key={value} className={styles.radioButtonContainer}>
          <RadioButton
            id={value.toString()}
            className={clsx(hasError && styles.radioButtonError)}
            checked={value === valueProp}
            value={value}
            onChange={() => onChange?.(value)}
          />
          <label htmlFor={value.toString()} className={styles.text}>
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

const RadioGroup: typeof ForwardedRadioGroup = forwardRef(ForwardedRadioGroup) as any;

export default RadioGroup;
